/* Carrusel del tema. Lo usan la sección de categorías y la de productos
   destacados, así que vive aquí en vez de duplicarse en cada una.

   Uso desde Liquid:

     <theme-carousel>
       <div data-carousel-track> ...tarjetas... </div>
       <div data-carousel-nav>
         <button data-carousel-prev>…</button>
         <button data-carousel-next>…</button>
       </div>
     </theme-carousel>

   El desplazamiento real lo hace el navegador con overflow + scroll-snap: este
   archivo solo mueve las flechas. Por eso en móvil se arrastra con el dedo
   aunque el JavaScript nunca cargue. */

class ThemeCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.nav = this.querySelector('[data-carousel-nav]');
    this.prev = this.querySelector('[data-carousel-prev]');
    this.next = this.querySelector('[data-carousel-next]');

    if (!this.track || !this.prev || !this.next) return;

    this.prev.addEventListener('click', () => this.scrollByPage(-1));
    this.next.addEventListener('click', () => this.scrollByPage(1));
    this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });

    // Al cambiar el ancho cambia cuántas tarjetas caben, así que hay que recalcular
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => this.updateArrows()).observe(this.track);
    } else {
      window.addEventListener('resize', () => this.updateArrows());
    }

    this.updateArrows();
  }

  /* Avanza por tarjetas COMPLETAS, no por el ancho visible.
     Importa porque el carril deja asomar la siguiente tarjeta: usando el ancho
     visible a secas, cada avance se comía ese pedazo de más y con el tiempo las
     tarjetas quedaban cortadas a media altura del recorrido. */
  scrollByPage(direction) {
    const slide = this.track.firstElementChild;
    if (!slide) return;

    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const step = slide.getBoundingClientRect().width + gap;
    if (!step) return;

    // La que se asoma no cuenta como visible: por eso floor y no round
    const perPage = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));

    this.track.scrollBy({ left: direction * perPage * step, behavior: 'smooth' });
  }

  updateArrows() {
    const max = this.track.scrollWidth - this.track.clientWidth;

    // Si todo cabe en pantalla no hay nada que navegar.
    // visibility (no display) para que las flechas no muevan el layout al aparecer.
    if (this.nav) this.nav.style.visibility = max < 2 ? 'hidden' : '';

    this.prev.disabled = this.track.scrollLeft <= 1;
    this.next.disabled = this.track.scrollLeft >= max - 1;
  }
}

if (!customElements.get('theme-carousel')) {
  customElements.define('theme-carousel', ThemeCarousel);
}
